import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import singleReport from '@/entities/insights/single-report/single-report.vue';
import ScrapboardManagerService from '@/entities/new-learning-center/scrapboard-manager.service';
import reportWeb from '@/entities/insights/modal/edit-reference/web/report-web.vue';
import reportSearch from '@/entities/insights/modal/edit-reference/search/report-search.vue';
import reportDocument from '@/entities/insights/modal/edit-reference/document/report-document.vue';
import reportText from '@/entities/insights/modal/edit-reference/text/report-text.vue';
import axios from 'axios';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { onlyInLeft, toDataURL } from '@/util/ds-util';
import { ReqestModel } from '@/shared/model/request-savecollection.model';
import detailReference from '@/entities/insights/selected-report/detail-reference/detail-reference.vue';
@Component({
  name: 'reference',
  components: {
    'single-report': singleReport,
    'web-report': reportWeb,
    'search-report': reportSearch,
    'document-report': reportDocument,
    'text-report': reportText,
    'vue-custom-scrollbar': vueCustomScrollbar,
    'detail-reference': detailReference,
  },
})
export default class reference extends Vue {
  @Inject('scrapboardManagerService') private scrapboardManagerService: () => ScrapboardManagerService;
  @Prop(Array) readonly lstReferenceId: string[] | undefined;
  @Prop(Boolean) readonly isEdit: any | undefined;
  @Prop() readonly detailReport: any | undefined;
  isTypeList = false;
  lstReference = [];
  isLoading = false;
  isLoadingEdit = false;
  lstSelectedDoc = [];
  selectedDoc = {};
  isShowSpinner = false;
  showDetail = false;
  oldList = [];

  created() {
    this.$root.$on('add-to-lst-reference', this.addToLstReference);
    this.$root.$on('select-reference-document', this.selectReferenceDocument);
    this.$root.$on('getSourceDocumentFromDetailReport', this.getSourceDocumentFromDetailReport);
  }

  destroyed() {
    this.$root.$off('add-to-lst-reference', this.addToLstReference);
    this.$root.$off('select-reference-document', this.selectReferenceDocument);
    this.$root.$off('getSourceDocumentFromDetailReport', this.getSourceDocumentFromDetailReport);
  }

  selectReferenceDocument(docId) {
    console.log('docId', docId);
    if (docId) {
      this.selectedDoc = document;
      this.isLoading = true;
      const params = {} as any;
      params.requestId = Date.now().toString();
      params.docIds = [docId];
      params.size = 1;
      params.page = 0;
      axios
        .post('/api/connectome-feeds/getListDocumentByIds', params)
        .then(async res => {
          if (res?.status === 200 && res?.data?.body?.result_code === 0) {
            this.selectedDoc = res?.data?.body?.data[0];
            this.showDetail = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          console.log('err', err);
          this.isLoading = false;
        });
    }
  }

  addToLstReference(lstAdd, isNote?) {
    let newDocLst = [];
    isNote
      ? (newDocLst = onlyInLeft(lstAdd, this.lstReference, ['title', 'content']))
      : (newDocLst = onlyInLeft(lstAdd, this.lstReference, ['id', 'url']));
    if (newDocLst.length > 0) this.lstReference.unshift(...lstAdd);
  }

  @Watch('lstReferenceId')
  showDataWhenChangeRerence() {
    if (Array.isArray(this.lstReferenceId)) {
      this.callApiGetAllReference(this.lstReferenceId);
    }
  }

  callApiGetAllReference(arrDocid) {
    this.isLoading = true;
    const params = {} as any;
    params.requestId = Date.now().toString();
    params.docIds = arrDocid;
    params.size = arrDocid.length;
    params.page = 0;
    axios
      .post('/api/connectome-feeds/getListDocumentByIds', params)
      .then(async res => {
        if (res?.status === 200 && res?.data?.body?.result_code === 0) {
          this.oldList = Object.assign([], res?.data?.body?.data);
          this.lstReference = res?.data?.body?.data;
          this.getSourceDocumentFromDetailReport();
        }
        this.isLoading = false;
      })
      .catch(err => {
        console.log('err', err);
        this.isLoading = false;
      });
  }

  onEditMode() {
    this.$emit('onEditMode', true);
  }

  onNormalMode() {
    this.$emit('onEditMode', false);
  }

  mounted(): void {
    const that = this;
    // @ts-ignore
    window.$('#modal-search-report').on('hide.bs.modal', function (e) {
      that.$root.$emit('clear-modal-data-search');
    });
    // @ts-ignore
    window.$('#modal-web-report').on('hide.bs.modal', function (e) {
      that.$root.$emit('clear-modal-data-web');
    });
    // @ts-ignore
    window.$('#modal-text-report').on('hide.bs.modal', function (e) {
      that.$root.$emit('clear-modal-data-text');
    });
    // @ts-ignore
    window.$('#modal-document-report').on('hide.bs.modal', function (e) {
      that.$root.$emit('clear-modal-data-document');
    });
  }

  sortLstReference(arg: boolean) {
    if (arg)
      this.lstReference.sort((a, b) => {
        if (!a.published_at) {
          return 1;
        }
        if (!b.published_at) {
          return -1;
        }
        return new Date(b.published_at).getTime() - new Date(a.published_at).getTime();
      });
    else this.lstReference = Object.assign([], this.oldList);
  }

  setSelectedItems(newData) {
    this.lstSelectedDoc = newData;
  }

  async callApiSaveScrapTemp() {
    this.isShowSpinner = true;
    const documents = [];
    const fileFormData = new FormData();
    let saveFile = false;
    const requestId = Date.now();
    const localStorageUser = JSON.parse(localStorage.getItem('localStorageUser'));
    const connectomeId = localStorageUser?.connectomeId;
    const userId = localStorageUser?.id;

    if (!connectomeId || !userId) {
      // this.customToast(this.$t('newLearningCenter.unknownError'), this.$t('newLearningCenter.error'), 'danger');
    }
    this.lstSelectedDoc.forEach(element => {
      if (element?.type) {
        if (element?.type !== 'FILE') {
          documents.push(this.convertReqUrl(element, connectomeId));
        } else {
          saveFile = true;
          fileFormData.append(element.document === 'drive' ? 'driveFiles' : 'localFiles', element.file);
        }
      }
    });

    let apiSaveDocumentPromise;
    let apiSaveFilePromise;

    if (documents.length) {
      apiSaveDocumentPromise = this.scrapboardManagerService().saveScrapTemp(
        documents.map(item => ({
          ...item,
          requestId: requestId,
          requestedScrapList: [],
          targetScrapboardId: '',
        }))
      );
    }

    if (saveFile) {
      const language = this.$i18n.locale;
      apiSaveFilePromise = axios.post(
        `api/learning/learning-center/savefile/${userId}/${connectomeId}?`
          .concat('forcedClustering=' + 'false')
          .concat('&requestId=' + requestId)
          .concat('&targetScrapboardId=""')
          .concat('&requestedScrapList=[]')
          .concat(language ? '&lang=' + language : 'en'),
        fileFormData
      );
    }

    const that = this;
    Promise.all([apiSaveDocumentPromise, apiSaveFilePromise])
      .then(function (results) {
        const successScrap = results?.[0]?.data?.body?.data?.length || 0;
        const successFile = results?.[1]?.data?.data?.length || 0;

        console.log('successScrap', successScrap);
        console.log('successFile', successFile);

        if (successScrap + successFile > 0) {
          that.isShowSpinner = false;
        } else {
          that.isShowSpinner = false;
        }
      })
      .catch(function (err) {
        that.isShowSpinner = false;
      });
  }

  getSourceDocumentFromDetailReport() {
    const report = Object.assign({}, this.detailReport);
    report.images = [report?.img];

    const referenceDocuments = this.lstReference.map(reference => reference);
    for (const referenceDocument of referenceDocuments) {
      referenceDocument.images = [referenceDocument?.image_url?.[0] || referenceDocument?.og_image_url];
      referenceDocument.id = referenceDocument.docId;
    }

    this.$root.$emit('calculateChatScrap', [{ docDetail: [report, ...referenceDocuments] }]);
  }

  convertReqUrl(element, connectomeId) {
    const objectTmp = new ReqestModel();
    if (!objectTmp.requestId) {
      objectTmp.requestId = Date.now() + Math.floor(Math.random() * 100);
    }
    objectTmp.title = element.title;
    objectTmp.forcedClustering = false;
    objectTmp.targetScrapboardId = [];
    objectTmp.requestedScrapList = [];
    objectTmp.path = element.url;
    objectTmp.content = element.content;
    objectTmp.type = element.type;
    objectTmp.connectomeId = connectomeId;
    objectTmp.author = element.author;
    if (objectTmp.type === 'USERNOTE') {
      objectTmp.content = element.content;
      objectTmp.description = '';
    } else {
      objectTmp.content = '';
      objectTmp.description = element.content;
    }
    objectTmp.searchType = element.searchType;
    objectTmp.favicon = element.favicon;
    objectTmp.lang = this.$i18n.locale || 'en';
    objectTmp.keyword = element.keyword;
    objectTmp.originDate = element.addedAt;
    objectTmp.docId = element.docId;
    objectTmp.img = element?.images?.[0] ? element.images[0] : '';
    return objectTmp;
  }

  gotoDetail(document) {
    this.showDetail = true;
    this.selectedDoc = document;
  }

  closeDetail() {
    this.showDetail = false;
  }

  selectOtherDoc(documentId) {
    const newSelected = this.lstReference.find(item => item.docId === documentId);
    if (newSelected) this.selectedDoc = newSelected;
  }
}
